module.exports = __webpack_public_path__ + "media/images/vector-137@2x-5c302378e7d5706d712c4d45f95ee93d.png";